export enum TipoAtendimentoCartorio {
    Virtual = 0,
    Presencial = 1,
}
